/**
 * Magniberg size chart (snippets/mb-size-chart.liquid).
 *
 * Switches a chart between centimetres and inches. Cells hold both values; the
 * `data-unit` attribute on the element decides which one the CSS shows.
 */
class MbSizeChart extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('click', this.#onClick, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('.mb-size-chart__unit') : null;
    if (!(button instanceof HTMLElement) || !button.dataset.unit) return;

    this.dataset.unit = button.dataset.unit;

    for (const unitButton of this.querySelectorAll('.mb-size-chart__unit')) {
      unitButton.setAttribute('aria-pressed', String(unitButton === button));
    }
  };
}

if (!customElements.get('mb-size-chart')) {
  customElements.define('mb-size-chart', MbSizeChart);
}
